import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="htmlcollection" id="htmlcollection"></a>
    <h1 {...{
      "id": "windowhtmlcollection"
    }}>{`window.HTMLCollection`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLCollection"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/HTMLCollection`}</a>{`  `}</p>
    <a name="nodelist-length" id="nodelist-length"></a>
    <h2 {...{
      "id": "length--number"
    }}>{`length : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="nodelist-item" id="nodelist-item"></a>
    <h2 {...{
      "id": "itemindex"
    }}>{`item(index)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Node`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="nodelist-keys" id="nodelist-keys"></a>
    <h2 {...{
      "id": "keys"
    }}>{`keys()`}</h2>
    <a name="nodelist-values" id="nodelist-values"></a>
    <h2 {...{
      "id": "values"
    }}>{`values()`}</h2>
    <a name="nodelist-entries" id="nodelist-entries"></a>
    <h2 {...{
      "id": "entries"
    }}>{`entries()`}</h2>
    <a name="nodelist-foreach" id="nodelist-foreach"></a>
    <h2 {...{
      "id": "foreachcallback"
    }}>{`forEach(callback)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callback`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      